
























































































    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../lib/util'
    import AbpBase from '../../lib/abpbase'
     
    import UtilUrl from '../../lib/url'
    import appconst from '../../lib/appconst'
    import PageRequest from "@/store/entities/page-request";
    import CreateRegularInspection from "./create-regularinspections.vue";
    import EditRegularInspection from './edit-regularinspections.vue';
   // const { exportToExcel } = require('@/lib/excel/tableExport.js');
    
  const { ExcelTest } = require('@/lib/excel/tableExportImg.js');
class PageBHUserRequest extends PageRequest {
  Keyword: string;
  enterpriseinformationid: number; //nullable
  status: number;
   
}
 
   @Component({
        components:{CreateRegularInspection}
    })
   
 export default class CreateRegularInspections extends AbpBase{


        
        @Prop({type:Boolean,default:false}) value:boolean;
     pagerequest: PageBHUserRequest = new PageBHUserRequest();
        
  createModalShow: boolean = false;
  editModalShow: boolean = false;
   modal1:boolean= false;
   modal2:boolean= false;
    modal11() {
      
    this.modal1 = true;
  }
   modal22() {
    this.modal2= true;
  }
    create() {
    this.createModalShow = true;
  }

   get list() {
                   
    return this.$store.state.regularinspections.rilist;
  }
  get loading() {
    return this.$store.state.regularinspections.riloading;
  }
   columns = [
    
   
       {
    
      title: this.L("单位名称"),
       width: 150,
      render: (h: any, params: any) => {
          var  corporatename= params.row.enterpriseInformation.corporatename ;
           

        return h("span", corporatename );
      },
    },
    
     {
      
      title: this.L("标题"),
      key: "title",
      width: 180, 
    },
     {
      
      title: this.L("内容"),
      key: "content",
       
    },
    {
    
      title: this.L("巡查类型"),
       width: 100,
      render: (h: any, params: any) => {
          var  regularinspectionstype=params.row.regularinspectionstype;
          var txt=this.getregularinspectionstypetxt(regularinspectionstype);
          
        return h("span", txt );
      },
    },
   
    {
    
      title: this.L("评分"),
       width: 100,
      render: (h: any, params: any) => {
          var  evaluate=params.row.evaluate;
          var txt=this.getevaluatetxt(evaluate);
          
        return h("span", txt );
      },
    },
     {
      title: "图片",
      key: "img",
      width: 200,
      render: (h: any, params: any) => {
            //var params.row.img
         
        var imgurl=[] ;
         if(params.row.img!=null&&params.row.img.length>0){
          var imglist=params.row.img.split(',');    
      
          imglist.forEach(items=>{
            
             var url=appconst.remoteServiceBaseUrl+"/"+items;
               
             imgurl.push(url)
          })
        }
     
      const imageElements = imgurl.map((src) => {
              return h('el-image', {
                props: {
                  src: src,
                  "preview-src-list": imgurl,
                 // fit: 'cover'
                },
                style: {
                 marginRight: '2px',
                 // marginBottom: '5px',
                  width: '40px',
                  height: '40px',
                  
                },
                key: src
              });
            });
          return h('div', imageElements);
    }

    }
    ,
    {  
      title: this.L("巡逻人"),
      key: "operatorname",
       width: 100,
    },
    
    {
    
      title: this.L("巡逻时间"),
      width: 150,
      render: (h: any, params: any) => {
          var  createtime=new Date(params.row.createtime).toLocaleString() ;
           

        return h("span", createtime );
      },
    },
     {
      title: this.L("Actions"),
      key: "Actions",
      width: 80,
      render: (h: any, params: any) => {
        return h("div", [
          
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteUserConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "regularinspections/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ),
        ]);
      },
    },
  

    
     
     
    
  ];
  async created() {
    //产废企业
   
      
    
  }


  get pageSize() {
    return this.$store.state.regularinspections.ripageSize;
  }
  get totalCount() {
    return this.$store.state.regularinspections.ritotalCount;
  }
  get currentPage() {
    return this.$store.state.regularinspections.ricurrentPage;
  }
  get corporatetypelist(){

    return this.$store.state.regularinspections.ricorporatetypelist;
  }
  pageChange(page: number) {
   
    this.$store.commit("regularinspections/setriCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
     
    this.$store.commit("regularinspections/setriPageSize", pagesize);
    this.getpage();
  }
  
  async getpage() {
    //this.pagerequest.corporatetype=1;
    this.pagerequest.maxResultCount = this.pageSize;
    
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "regularinspections/getregularinspectionsAll",
      data: this.pagerequest,
    });
  }




         
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        getevaluatetxt(id){
            var txt="";
               var list =this.$store.state.regularinspections.evaluate;
             list.forEach(item=>{
                   if(id==item.id){
                    txt=item.name;
                    return txt;
                   }

             })
             return txt;
        }
        getregularinspectionstypetxt(id){

          var txt="";
               var list =this.$store.state.regularinspections.regularinspectionstype;
             list.forEach(item=>{
                   if(id==item.id){
                    txt=item.name;
                    return txt;
                   }

             })
             return txt;
        }
        

          //导出
   /*async  exportExcel() {
   
     this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "regularinspections/getAllexportExcel",
      data: this.pagerequest,
    });
 
      if(lt!=null){       
       
            
            
			   	require.ensure( [], () => {
					const { export_json_to_excel } = require('@/lib/excel/export2Excel.js');
          
					// 这里深拷贝，修改值时不会影响到原对象
				  
					lt.map((item) => { // 这里修改要下载的字段内容
					  item.corporatename=item.  enterpriseInformation.corporatename;
            item.evaluate=this.getevaluatetxt(item.evaluate);
            item.regularinspectionstype=this.getevaluatetxt(item.regularinspectionstype);
             
           var imgurl=[] ;
            var imglist=item.img.split(',');    
        
          imglist.forEach(items=>{
           var baseurl=appconst.remoteServiceBaseUrl
            var nowurl=baseurl+"/"+items;
            imgurl.push(nowurl)
            
          })
           item.img=imglist;
    
            item.img=imgurl.join(",");
            item.createtime=new Date(item.createtime).toLocaleString()
					  return item;
					});
    
					const filterVal = ['id', 'corporatename','regularinspectionstype','title','content' , 'img','evaluate','operatorname','createtime' ];// 取出要下载的表头字段
					const tHeader = ['编号','企业名称','巡查类型','标题','内容','图片','评价','操作人','巡查时间'];// 把表头字段定义成想要的中文或英文
					console.log(lt)
          const data = this.formatJson(filterVal, lt);
					  export_json_to_excel(tHeader, data, '巡查记录');// 定义excel下载成功的表名
					});			
								
             }

        }

			formatJson(filterVal, jsonData) {
			     return jsonData.map(v => filterVal.map(j => v[j]))
			}
      */


     async  exportExcel(){

        this.pagerequest.maxResultCount = 999999999;
     this.pagerequest.skipCount =0;
     let lt= await this.$store.dispatch({
      type: "regularinspections/getAllexportExcel",
      data: this.pagerequest,
    });
      
      
      
      
      
      var datalist=new Array<object>();
      if(lt!=null){       
       
            
            
			   	 
          
					// 这里深拷贝，修改值时不会影响到原对象
				
				  	lt.map((item) => { // 这里修改要下载的字段内容
					  var corporatename=item.enterpriseInformation.corporatename;
            var evaluate=this.getevaluatetxt(item.evaluate);
            var regularinspectionstype=this.getevaluatetxt(item.regularinspectionstype);
           
           item. corporatename=corporatename;
           item.evaluate=evaluate;
           item.regularinspectionstype=regularinspectionstype;
          var imgurl=[] ;
      
          var imglist=item.img.split(',');    
        
          imglist.forEach(items=>{
           var baseurl=appconst.remoteServiceBaseUrl
            var nowurl=baseurl+"/"+items;
            imgurl.push(nowurl)
            
            var img = new Image();
            img.src = nowurl;
         
       
           
          })
          item.imgurl=imgurl;
          var createtime=new Date(item.createtime).toLocaleString()
          item.createtime=createtime;
          datalist.push(item)
					  return item;
					});
          

          var dt=lt;
					const filterVal = ['id', 'corporatename','regularinspectionstype','title','content' , 'imgurl','evaluate','operatorname','createtime' ];// 取出要下载的表头字段
				//	const tHeader = ['编号','企业名称','巡查类型','标题','内容','图片','评价','操作人','巡查时间'];// 把表头字段定义成想要的中文或英文
				  console.log(datalist)
         // const data= this.formatJson(filterVal, datalist);
      
          var  tHeader= [
     {
			title: '企业名称',
			key: 'corporatename',
			type: 'text',
		},
      {
			title: '巡查类型',
			key: 'corporatename',
			type: 'text',
		},
      {
			title: '标题',
			key: 'title',
			type: 'text',
		},
      {
			title: '内容',
			key: 'content',
			type: 'text',
		},
		{
			title: '图片',
			key: 'imgurl',
			type: 'image',
			//width: 30,
			//height: 30,
		}
    ,
      {
			title: '评价',
			key: 'evaluate',
			type: 'text',
		}
    ,
      {
			title: '操作人',
			key: 'operatorname',
			type: 'text',
		}
    ,
      {
			title: '巡查时间',
			key: 'createtime',
			type: 'text',
		}
    ]
  /*
var tHeader1=[   {
			title: '内容',
			key: 'name',
			type: 'text',
		},
		{
			title: '图片',
			key: 'url',
			type: 'image',
			//width: 30,
			//height: 30,
		}]
 
             var  tbody= [   {
				name: '玫瑰花2',
				url: ['https://localhost:44311/UploadFile/RegularInspectionsFiles/e6eeaba3-b28a-42e5-b12e-022b5eb26288.jpg','https://localhost:44311/UploadFile/RegularInspectionsFiles/t2.jpg']
			}
       
  
                    
      ]

         ExcelTest(tHeader1, tbody, "巡查记录1");*/

         // console.log(data)
         //导出图片必须是原生图片，直接改后缀会导致excel里面图片出不来
          ExcelTest(tHeader, datalist, "巡查记录");
          }
          
         
       
               
             //   ExcelTest(tHeader, data, "导出数据_");
              
       }
 
  
   getBase64Image(img) {
        var canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        var ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, img.width, img.height)
        const dataURL = canvas.toDataURL('image/jpeg') // 可根据图片后缀，动态变换如 image/png
        return dataURL
      }

        getBase64(url, callback) {
     
           
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // 如果图片需要跨域访问
      img.onload = () => {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        callback(null, canvas.toDataURL('image/png'));
      };
      img.onerror = () => {
        callback('Error loading image', null);
      };
      img.src = url;
    
  }

   

        
 

         visibleChange(value:boolean){
           
            if(!value){
                this.$emit('input',value);
                
            }else{

                  
   /* var efid=this.$store.state.regularinspections.riefid;
    if(efid==undefined){
      efid=0;
    }*/
   var  efid= window.sessionStorage.getItem("regularinspections_riefid");
   if(efid==""||efid==null){
     efid="-1";
   }
 
      this.pagerequest.enterpriseinformationid=parseInt(efid) ;
      this.getpage();
            }
        }
  }
   
        
            
